import {Box,Grid,Button,TextField,Typography,Stack, Fab,Link } from '@mui/material'
import React, {useRef,useState,useEffect} from 'react';
import { send } from '@emailjs/browser';
import Footer from './components/Footer';
import PhotoGallery from './components/Gallery';
import CustomerGallery from './components/CustomerGallery';
import Header from './components/Header';
import Service from './components/Service';
import box from './res/services/converted-box.jpg'
import tumbler from './res/services/tumbler.webp'
import wine from './res/services/wine.webp'
import topper1 from './res/services/topper1.webp'
import mirror from './res/services/mirror.webp'
import partyFavor from './res/services/party-favours.webp'
import review from './res/services/review.webp'
import otherServices from './res/services/other-services50.webp'
import { createTheme } from "@mui/material/styles";
import { ThemeProvider } from '@mui/system';
import FacebookIcon from '@mui/icons-material/Facebook';
import InstagramIcon from '@mui/icons-material/Instagram';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
import Image from 'mui-image'
import InnerPage from './components/InnerPage'




let theme= createTheme({
  palette:{
    primary:{
      // light:'#fcf1f4',
      light:"#f5f0f1",
      main:'#f3abbc',
      dark:'#c28996'

    },
    secondary:{
      light:'#f2e6d3',
      // light:'#fff2d7',
      main:'#d2a55a',
      dark:'#6a4f29',
    }
  },
  typography:{
    h2:{
      fontFamily:[
        'Dancing Script,cursive'
      ],
      
      
    }
  }
})

const heading={
  fontSize:{xs:'38px',md:'44px',lg:'50px'}
}


// const fontTheme = createTheme({
//   typography: {
//     fontFamily: [
//       'Indie Flower',
//       'cursive',
//     ].join(','),
    
//   },});

let fabStyle = {
  backgroundColor:'primary.main',
  '&:hover':{
    backgroundColor:'primary.dark'
  }

}

const scrollBar = {
  '&::-webkit-scrollbar': {
    width: '0.6em',
    height:'0.6em'
  },
  '&::-webkit-scrollbar-track': {
    '-webkit-box-shadow': 'inset 0 0 6px rgba(0,0,0,0.00)'
  },
  '&::-webkit-scrollbar-thumb': {
    backgroundColor: 'rgba(0,0,0,.2)',
    borderRadius: 2
    
  },
  '&::-webkit-scrollbar-thumb:hover': {
      backgroundColor: 'rgba(0,0,0,.4)',
      
    }
}

function App() {
  let homeRef=useRef()
  let aboutRef=useRef()
  let galleryRef=useRef()
  let serviceRef=useRef()
  let contactRef=useRef()
  let otherServicesRef=useRef()
  let customerRef=useRef()
  let termRef=useRef()


  let[emailName,setEmailName]=useState("")
  let[emailAddress,setEmailAddress]=useState("")
  let[emailMessage,setEmailMessage]=useState("")
  let[emailError, setEmailError]=useState('none')
  let sendEmail=async()=>{
    console.log('shoot')
    if(/\S+@\S+\.\S+/.test(emailAddress)&&emailAddress!==""&&emailMessage!==""){
      send('service_y4w6yh9','template_v1g8c0i',
      {from_name:emailName,
        to_name:"D'Core",
        message:emailMessage,
        reply_to:emailAddress},
        'PMbuGmUBbitnn0i_o'
        )
        .then((res)=>{
          console.log('SUCCESS!', res.status, res.text)
          setEmailAddress("")
          setEmailName("")
          setEmailMessage("")
          setEmailError('none')
        })
        .catch((err)=>{
          console.log('FAILED...', err);
          setEmailError('block')
        })
    }
    else{setEmailError('block')}
  }





  const size_theme = useTheme()
  const md_down = useMediaQuery(size_theme.breakpoints.down('md'));
  const sm_down = useMediaQuery(size_theme.breakpoints.down('sm'));
  const sm_up = useMediaQuery(size_theme.breakpoints.up('sm'));
  const lg_up = useMediaQuery(size_theme.breakpoints.up('lg'));
  const xs_only = useMediaQuery(size_theme.breakpoints.only('xs'));

  
  function useWidth() {
    const theme = useTheme();
    const keys = [...theme.breakpoints.keys].reverse();
    return (
      keys.reduce((output, key) => {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const matches = useMediaQuery(theme.breakpoints.up(key));
        return !output && matches ? key : output;
      }, null) || 'xs'
    );
  }

  const width = useWidth();
  let serviceImgHeight;
  let serviceImgWidth;
  switch(width){
    case 'xs':
      serviceImgWidth='330px'
      serviceImgHeight='247px'
      break;
    case 'sm':
      serviceImgWidth='500px'
      serviceImgHeight='386px'
      break;
    case 'md':
      serviceImgWidth='560px'
      serviceImgHeight='433px'
      break;
    case 'lg':
      serviceImgWidth='620px'
      serviceImgHeight='479px'
      break;
    case 'xl':
      serviceImgWidth='700px'
      serviceImgHeight='541px'
      break;

  }
 
  
  return (
    <ThemeProvider theme={theme}>
    <Box backgroundColor='#fff' ref={homeRef} width='100vw' sx={{display:'flex',flexDirection:'column', }}>
      <Header home={homeRef} gallery={galleryRef} services={serviceRef} contact={contactRef} customer={customerRef}/>
      <Box  justifyContent='center' pt={0}>

      <Typography align='center' variant='h2' color='primary.main' 
       sx={{...heading,mt:4}}>Welcome to D'Core Paperie</Typography>

      <Box  ref={galleryRef}  sx={{height:1, }} mt={4} alignItems='center' justifyContent='center' display='flex'>
        {/* {xs:'540px',sm:'800px',md:'850px',xl:'1000px'} */}
          <PhotoGallery/>

        </Box>


      <Box  height={1}pt={2}
      >
        <Typography  ref={aboutRef} variant="h2" sx={{...heading,pb:4}} align="center" color="primary.main">About Us</Typography>
          
        <Typography variant='h4' color='secondary.dark' align='center' 
        fontSize={{xs:20,md:25,lg:30}} fontFamily='Assistant' sx={{mx:{xs:4,md:16,lg:32},lineHeight: "38px", mb:0}}>
        D’Core Paperie is a small business located on Tortola, British Virgin Islands, 
        that was launched in 2020 with the hope of 
        breathing a new life into the art of paper goods. We 
        specialize in personalized favors, personalized custom
         stationary, home decor & gift arrangements. All of our
          stationary and personalized gifts are designed, printed
           and handmade by us.</Typography>
      </Box>


      


        

{/* 
      Acrylic Tumblers - $20
Wine Glasses - Stem ($20) Stemless ($15) 
Personalize Gift Boxes - $50 and up 
Cake Toppers - $10 and up 
Personalized Mirror Stand - $50 and up 
Party Treats - Packages Available */}


        <Box  ref={serviceRef} width={1} mt={4} pt={{xs:4,sm:6,md:8}} sx={{display:'flex',alignItems:'center',flexDirection:'column'}}>
          
            <Typography variant='h2' align='center' sx={{...heading,color:'primary.main',width:1,marginBottom:2}}>Featured Services</Typography>
          

          <Box  alignItems='center' width='90vw' justifyContent='center' 
          sx={{...scrollBar,backgroundColor:'secondary.light',flexDirection:'column',overflow:'auto',display:'center',borderRadius:4,py:{xs:2,md:4}}}>
            

              <Stack >
              <Stack direction='row' sx={{marginX:4}}>
              
              <Service name="Acrylic Tumblers" description= "This is a box, a box is a box about boxes that contains boxes" price="$20.00" image={tumbler}/>
              <Service name="Wine Glasses" description= "This is a box, a box is a box about boxes" price="Stem($20) Stemless($15)" image={wine}/>
              <Service name="Personalized Gift Boxes" description= "This is a box, a box is a box about boxes that contains boxes" price="Starts at $50.00" image={box}/>
              
              
              </Stack>

              <Stack justifyContent='center' direction='row' sx={{marginX:4}}>
              
              
              <Service name="Cake Toppers" description= "This is a box, a box is a box about boxes that contains boxes" price="Starts at $10.00" image={topper1}/>
              <Service name="Personalized Mirror" description= "This is a box, a box is a box about boxes that contains boxes" price="Starts at $50.00" image={mirror}/>
              
              
              </Stack>
              </Stack>
            
          
        </Box>
        </Box>
        
        <Box  ref={otherServicesRef} height={1}  pt={{xs:4,md:8}} pb={4}  
        sx={{display:'flex',flexDirection: 'column',alignItems:'space-around'}}>
          





        

          <Typography sx={{...heading,pb:{xs:4,sm:4,md:6,}}} variant='h2' align='center'  color='primary.main'>Other Services</Typography>
         {/* <Stack direction={{xs:'column',lg:'row'}} justifyContent='center' alignItems='center' gap={16} > */}
            {/* <Box sx={{background:`url(${partyFavor})`,backgroundSize: 'cover',borderRadius:2}} */}
             {/* width={md_down?'360px':'440px'} height={md_down?'425px':'520px'} */}
             {/* /> */}



      <Box sx={{display:'flex',flexDirection: {xs:'column',lg:'row'},justifyContent:'space-evenly'}}>

      
        <Box display='flex' sx={{justifyContent:'center', alignItems:'center', }} >

          <Image src={otherServices}
          loading='lazy'
          fit='contain'
          width={serviceImgWidth}
          height={serviceImgHeight}
          //  width={sm_down?'380px':'540px'}
          //  height={sm_down?'500px':'630px'}
          sx={{borderRadius:6, boxShadow:0 ,pb:{xs:2,lg:0}, pr:{xs:0,lg:2}}}/>
        </Box>

             <Box  display='flex' alignItems='center' justifyContent='center'  >
                <Image src={partyFavor}
                loading='lazy'
              fit='contain'
              width={serviceImgWidth}
              height={serviceImgHeight}
              //  width={sm_down?'380px':'540px'}
              //  height={sm_down?'540px':'610px'}
              sx={{borderRadius:6, boxShadow:0,pt:{xs:2,lg:0}, pl:{xs:0,lg:2}}}/>
             </Box>
             </Box>
            {/* <Box backgroundColor='secondary.light' p={4} borderRadius={4}>
              <ul> 
                <li>
                  <Typography variant='h6'>This is a sevice</Typography>
                </li>

                <li>
                  <Typography variant='h6'>This is a sevice</Typography>
                </li>

                <li>
                  <Typography variant='h6'>This is a sevice</Typography>
                </li>
              </ul>
            </Box> */}
            {/* <Box sx={{background:`url(${otherServices})`,backgroundSize: 'cover',borderRadius:2}} width={md_down?'370px':'460px'} height={md_down?'408px':'508px'}/> */}
            
            
        
          {/* </Stack> */}
         
        </Box>

        <Box ref={customerRef} height={1} backgroundColor='primary.main' px={{xs:2,md:4}} pt={{xs:4,sm:6,md:8}} pb={4}  sx={{display: 'flex',flexDirection: 'column',justifyContent:'center'}} >
        <Typography variant='h2' color='white' align='center' sx={{...heading,mb:4}}>Our Happy Customers </Typography>
          <Stack direction='column' justifyContent= 'center' gap={2} sx={{px:{xs:2,md:8}}}>
          
            <Box>
              <Typography variant={md_down?'h5':'h4'} color='white' fontFamily='Quicksand' align='left'>"You have a new customer, great customer service with great turnaround time"</Typography>
              {/* <Typography variant={md_down?'h6':'h5'}sx={{ml:8}} color='white' align='left'>-fisrtname lastname</Typography> */}
            </Box>

            {/* <Box>
              <Typography variant={md_down?'h6':'h4'} color='white'>"You always come through"</Typography>
              <Typography variant='h5' color='white'>~fisrtname lastname</Typography>
            </Box> */}
            

          
            {/* <Box>
              <Typography variant={md_down?'h6':'h4'} color='white'>"This is a very good review"</Typography>
              <Typography variant='h5' color='white'>~fisrtname lastname</Typography>
            </Box> */}

            <Box>
              <Typography variant={md_down?'h5':'h4'} fontFamily='Quicksand' color='white' align='right'>"You always come through!"</Typography>
              {/* <Typography variant={md_down?'h6':'h5'} color='white' align='right' sx={{ml:8}}>-fisrtname lastname</Typography> */}
            </Box>
          


            
          </Stack>
          
          <Box justifyContent='center' display='flex' alignItems='center' pt={4} px={4}>
          
                {/* <Image src={review} 
                fit='contain'
                // width={xs_down? 1:'540px'}
                height={reviwImgHeight}
                // width='500px'
               
                boxShadow={4}
            //  width={sm_down?'490px':'540px'}
            //  height={sm_down?'490px':'630px'}
             /> */}

                <CustomerGallery/>
              </Box>


              
          
          
          
        </Box>

        {/* <Box height={1} justifyContent="center" mt={1} mb={1}>
          <CustomerGallery/>
        </Box> */}

        <Box ref={termRef} justifyContent='center' widht={1}sx={{paddingX:{xs:2,md:4},paddingY:4,marginTop:8}} alignItems='center' display='flex'>
          <InnerPage title='Terms of Service'
          body={['Processing Time for tumblers, water bottles and pouches are 3-5 business days. Processing Time for ALL bulk orders are 1-2 weeks. ',
          'Special Order tumblers and bottles  requires a 1-2 week processing time. Processing Time for all Paperie Products are 1-3 weeks.',
          'If items are needed before the processing time a rush fee will be added to your invoice.',
          'All personalized items must be picked up within 3 business days. If items are not picked up they will be sold. Personalized items require a 50% deposit. To reserve an order a deposit must be made. ',
          'Due to the nature of our custom products, all sales are final. If your item is received damaged we must be notified within 24 hours of receipt. We only replace items if they are defective or damaged. We must be notified within 24 hours of receipt. We will exchange it for the same item, send us an email or call us directly.',
          'Your graphics are reserved when deposit is made. If more graphics are required, an extra fee will be added to the total amount due. Upon delivery your remaining balance will be due for your order.'

        ]}
          // "
            
            
             
            
             
            
          // "
          />
        </Box>
        


{/* <Typography align="justify" variant="subtitle2">DELIVERY SERVICES ARE AVAILABLE:</Typography>
<Typography align="center" variant="subtitle2">ROAD TOWN - $5.00</Typography>
<Typography align="center" variant="subtitle2">SEA COWS BAY - $3.00</Typography>
<Typography align="justify" variant="subtitle2">We accept payments through Cash, ATH Movil and Direct Deposit.</Typography>
  */}

        <Box px={{xs:2,sm:12,md:24}} pb={8} ref={contactRef}  >
              <Grid container rowSpacing={2} alignItems='center' justifyContent='center' >
                <Typography sx={{...heading,pt:8}}variant='h2' align='center' color='primary.main'>Contact Me</Typography>
                <Grid container item xs={12} justifyContent='center'>
                  <Stack gap={2} justifyContent='center'>
                    <Stack direction='row' gap={2} padding={1} justifyContent='center'>
                      <Fab  size={md_down?'small':'medium'} sx={fabStyle} component={Link} href='https://www.instagram.com/dcorepaperie/' target="_blank" rel="noopener">
                        <InstagramIcon size="large"/>
                      </Fab>
                      <Fab size={md_down?'small':'medium'}  sx={fabStyle} component={Link} href='https://www.facebook.com/dcorepaperie/' target="_blank" rel="noopener">
                        <FacebookIcon/>
                      </Fab>
                      <Fab size={md_down?'small':'medium'}  sx={fabStyle} component={Link} href="https://www.google.com/maps/place/18%C2%B024'35.2%22N+64%C2%B040'12.2%22W/@18.4097724,-64.6700624,17z/data=!3m1!4b1!4m5!3m4!1s0x0:0x52fa21f536bcef88!8m2!3d18.4097724!4d-64.6700624" target="_blank" rel="noopener">

                        <LocationOnIcon/>
                      </Fab>
                    </Stack>
                    <Box alignItems='center' justifyContent='center' display='flex'><WhatsAppIcon sx={{color:'primary.dark',fontSize:{xs:24,sm:32}}}/>
                    <Typography display='inline' variant='h6' color='primary.dark' fontSize={{xs:18,sm:24}} sx={{pr:1}}>/ATH: </Typography> 
                    <Typography display='inline' variant='h6' color='primary.dark'  fontSize={{xs:18,sm:20}}> (284)496-8004</Typography></Box>
                    
                  </Stack>
                  
                 
                </Grid>
              <Grid item xs={12}>
                <Typography variant='h6' color='secondary.dark'>Send me an Email</Typography>
              </Grid>
              
              <Grid item xs={12} md={6} sx={{pr:{xs:0,md:1}}}>
                <TextField fullWidth label="Your Name" value={emailName} onChange={(e)=>{setEmailName(e.target.value)}}/>
              </Grid>

              <Grid item xs={12} md={6} sx={{pl:{xs:0,md:1}}}>
                <TextField fullWidth label="Your Email" value={emailAddress} onChange={(e)=>{setEmailAddress(e.target.value)}}/>
              </Grid>
          
              <Grid item  xs={12}>
                <TextField fullWidth multiline rows={12} label="Your Message" value={emailMessage} onChange={(e)=>{setEmailMessage(e.target.value)}}/>
              </Grid>

              <Grid container item xs={6} justifyContent="space-between">
                <Typography variant="subtitle1" color='red' sx={{display:emailError}}>Invalid. Please check information and try again</Typography>
                
              </Grid>
              <Grid container item xs={6} justifyContent="flex-end">
                
                <Button variant="contained" sx={{color:'white'}} onClick={(e)=>{sendEmail()}}>Send</Button>
              </Grid>
              
            </Grid>
      </Box>
      </Box>
      
      <Footer home={homeRef} about ={aboutRef} gallery={galleryRef} services={serviceRef} 
      otherServices={otherServicesRef} customers={customerRef}
      terms={termRef}contact={contactRef}/>

      
    </Box>
    </ThemeProvider>
  );
}

export default App;
